<mat-sidenav-container class="contact-list__root container" [hasBackdrop]="true">
  <mat-sidenav class="fixed" #drawer [mode]="'over'" position="start">
    <app-organizations
      [profile]="profile() || undefined"
      (logout)="onLogout()"
      (close)="drawer.toggle()"
      (selected)="onOrganizationSelected($event)"
    ></app-organizations>
  </mat-sidenav>
  <section class="contact-list__root_logo-ctn header">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="header__content">
          <div class="left">
            <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
              <mat-icon>menu</mat-icon>
            </button>
            <h3>{{ currentOrganization()?.description }}</h3>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </section>
  <section class="contact-list">
    <app-dashboard-section-header
      [headerText]="alertHistoryHeaderText()"
      [hideAddButton]="true"
      [hideCollapseButton]="true"
    >
      <form class="alert-history-filters" [formGroup]="filterForm" (ngSubmit)="runSearch()">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="alert-history-filters__campaign">
          <mat-label>Campaign</mat-label>
          <mat-select formControlName="campaignId">
            <mat-option [value]="campaignAll">All campaigns</mat-option>
            <mat-option [value]="campaignManual">N/A</mat-option>
            @for (campaign of campaigns(); track campaign.id) {
              <mat-option [value]="campaign.id">{{ campaign.title }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="alert-history-filters__date">
          <mat-label>{{ dateRangeRequired() ? 'Date range' : 'Date range (optional)' }}</mat-label>
          <mat-date-range-input [rangePicker]="picker" formGroupName="dateRange">
            <input matStartDate formControlName="start" placeholder="From" />
            <input matEndDate formControlName="end" placeholder="To" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="alert-history-filters__search">
          <mat-label>Search</mat-label>
          <input matInput formControlName="search" placeholder="Subject, phone, or campaign" />
        </mat-form-field>

        <div class="alert-history-filters__actions">
          <button mat-flat-button color="primary" type="submit" [disabled]="!canRun()">
            {{ alertsLoading() ? 'Running…' : 'Run' }}
          </button>
          <button
            mat-stroked-button
            type="button"
            (click)="clearFiltersAndResults()"
            [disabled]="alertsLoading()"
          >
            Clear
          </button>
          <button
            mat-stroked-button
            type="button"
            [matMenuTriggerFor]="exportMenu"
            [disabled]="!canExport()"
          >
            Export
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #exportMenu="matMenu">
            <button mat-menu-item type="button" (click)="exportCsv()" [disabled]="exportLoading()">
              CSV
            </button>
            <button mat-menu-item type="button" (click)="exportXlsx()" [disabled]="exportLoading()">
              Excel (.xlsx)
            </button>
          </mat-menu>
        </div>
      </form>
      <p class="alert-history-filters__hint">
        @if (dateRangeRequired()) {
          Dates filter by alert created time (your local timezone). Required for All campaigns and N/A.
        } @else {
          Optional date range narrows by alert created time (your local timezone).
        }
      </p>

      <app-alert-status-legend></app-alert-status-legend>
      @if (alertsLoading()) {
        <div class="loading">
          <mat-card appearance="outlined" class="place_holder">
            <mat-card-content>
              <app-skeleton
                viewBox="0 0 150 24"
                [speed]="2"
                backgroundColor="#E0DCDC"
                foregroundColor="rgba(0, 0, 0, 0.1)"
              >
                <svg:rect x="3" y="0" rx="0" ry="0" width="50%" height="9" />
                <svg:rect x="3" y="12" rx="0" ry="0" width="35%" height="9" />
              </app-skeleton>
            </mat-card-content>
          </mat-card>
        </div>
      } @else if (hasRun()) {
        @if (alerts().length > 0) {
          <div class="alert-history-list white-background-content">
            <div class="alert-history-list__head cycle-row">
              <button
                type="button"
                class="alert-history-list__sort cycle-row__when"
                [class.alert-history-list__sort--active]="historySortKey() === 'initiatedOn'"
                (click)="toggleHistorySort('initiatedOn')"
              >
                <span>Date</span>
                @if (historySortIcon('initiatedOn'); as icon) {
                  <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
                }
              </button>
              <span class="alert-history-list__head-label cycle-row__info">Details</span>
              <button
                type="button"
                class="alert-history-list__sort cycle-row__status"
                [class.alert-history-list__sort--active]="historySortKey() === 'status'"
                (click)="toggleHistorySort('status')"
              >
                <span>Status</span>
                @if (historySortIcon('status'); as icon) {
                  <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
                }
              </button>
            </div>
            @for (alert of sortedAlerts(); track alert.id) {
              <article
                class="alert-history-card"
                role="link"
                tabindex="0"
                (click)="openAlertLog(alert)"
                (keydown.enter)="openAlertLog(alert)"
              >
                <div class="cycle-row">
                  <span class="cycle-row__when">{{ formatDate(alert.initiatedOn) }}</span>
                  <div class="cycle-row__info">
                    <p class="alert-history-card__row">
                      <span class="alert-history-card__label">Campaign Title:</span>
                      <span class="alert-history-card__value">{{ alert.campaignTitle || 'N/A' }}</span>
                    </p>
                    <p class="alert-history-card__row">
                      <span class="alert-history-card__label">Callback Location:</span>
                      <span class="alert-history-card__value">{{ alert.callbackLocationName }}</span>
                    </p>
                    <p class="alert-history-card__row">
                      <span class="alert-history-card__label">Contact:</span>
                      <span class="alert-history-card__value">{{ contactAttemptedLine(alert) }}</span>
                    </p>
                    <p class="alert-history-card__row">
                      <span class="alert-history-card__label">{{ subjectSingular() }}:</span>
                      <span class="alert-history-card__value">{{ alert.patientName }}</span>
                    </p>
                  </div>
                  <span
                    class="cycle-row__status alert-history-card__badge"
                    [class.alert-history-card__badge--inProgress]="alertStatusBadgeVariant(alert.status) === 'inProgress'"
                    [class.alert-history-card__badge--canceled]="alertStatusBadgeVariant(alert.status) === 'canceled'"
                    [class.alert-history-card__badge--connected]="alertStatusBadgeVariant(alert.status) === 'connected'"
                    [class.alert-history-card__badge--acknowledged]="alertStatusBadgeVariant(alert.status) === 'acknowledged'"
                    [class.alert-history-card__badge--noResponse]="alertStatusBadgeVariant(alert.status) === 'noResponse'"
                    [class.alert-history-card__badge--unknown]="alertStatusBadgeVariant(alert.status) === 'unknown'"
                  >
                    {{ alertStatusLabel(alert.status) }}
                  </span>
                </div>
              </article>
            }
          </div>
          <div class="alert-history-paging">
            <button mat-stroked-button type="button" (click)="goToPreviousPage()" [disabled]="pageIndex() === 0">
              Previous
            </button>
            <span class="alert-history-paging__label">Page {{ pageIndex() + 1 }}</span>
            <button mat-stroked-button type="button" (click)="goToNextPage()" [disabled]="!hasNextPage()">
              Next
            </button>
          </div>
        } @else {
          <div class="alert-history-empty white-background-content">
            <p class="active-alerts-empty__title">No alerts match these filters.</p>
          </div>
        }
      } @else {
        <div class="alert-history-empty white-background-content">
          <p class="active-alerts-empty__title">Set filters and Run to load alert history.</p>
        </div>
      }
    </app-dashboard-section-header>
  </section>
</mat-sidenav-container>
